import {SEARCH_OTHER_PAGES} from "~/utils/search/search.constants";

export default {
  props: {
    item: {
      type: Object,
      default: null
    },
    hasTranslation: {
      type: Boolean,
      default: false
    },
    withCount: {
      type: Boolean,
      default: true
    },
    isChecked: {
      type: Boolean
    },
    returnField: {
      type: String,
      default: 'key'
    },
    show: {
      type: Boolean,
      default: true
    },
    isLink: {
      type: Boolean,
      default: false
    },
    filterKey: {
      type: String,
      default: ''
    }
  },
  filters: {
    normalize (val) {
      return val.replace(' ', '-').toLowerCase()
    }
  },
  methods: {
    onClickLink (e) {
      e.preventDefault()
      this.onClick()
    },
    onClick () {
      this.$emit('change', [this.filterKey, this.item[this.returnField]])
    }
  },
  computed: {
    getFilterLink () {
      let result = this.$Search.getFilterUrl(this.filterKey, this.item[this.returnField])
      if (SEARCH_OTHER_PAGES.includes(this.$route.name)) {
        result = result.split('?')[0]
      }
      return result
    },
    isSelected () {
      return this.$Search.attributeInList(this.filterKey, this.item[this.returnField])
    },
    getText () {
      const text = this.hasTranslation ? this.$t(this.$options.filters.normalize(this.item.name)) : this.item.name
      return text.charAt(0).toUpperCase() + text.slice(1)
    },
    getCount () {
      return  this.filterKey === 'subLocations' ? this.item.unfiltered_count : this.item.count
    }
  }
}
